
import ogPagesMixins from '@/mixins/ogPagesMixins'
import isClient from '@/mixins/isClient'
export default {
  mixins: [ogPagesMixins, isClient],
  layout: 'clear',
  scrollToTop: true,
  props: {
    author: {
      type: Object,
      default: null,
    },
    seoAuthorName: {
      type: String,
      default: '',
    },
  },
  async asyncData({ $axios, route, error }) {
    try {
      const { recommendation, target } = await $axios.$get(
        `/recommendations/${route.params.id}`
      )
      return {
        recommendation,
        target,
      }
    } catch (err) {
      const statusCode = err.response.data.statusCode
      const message = err.response.data.message
      error({
        statusCode,
        message,
      })
    }
  },

  data() {
    return {
      seoType: 'article',
      isShowMenu: false,
      recommendation: null,
    }
  },

  fetch() {
    this.setView()
  },
  computed: {
    getTargetText() {
      return 'Рекомендация'
    },
    // seoImage() {
    //   return {
    //     url: this.recommendation?.ogImg
    //       ? `https://img.megasreda.ru/optimize?src=${this.recommendation?.ogImg}&size=1200&format=jpeg`
    //       : `https://api.megasreda.ru/image/ogimage/${this.recommendation?._id}.jpg`,

    //     urlVk: this.recommendation?.ogImgVk
    //       ? `https://img.megasreda.ru/optimize?src=${this.recommendation?.ogImgVk}&size=1020&format=jpeg`
    //       : `https://api.megasreda.ru/image/ogimage/vk/${this.recommendation?._id}.jpg`,

    //     urlTw: this.recommendation?.ogImg
    //       ? `https://img.megasreda.ru/optimize?src=${this.recommendation?.ogImg}&size=1200&format=jpeg`
    //       : `https://api.megasreda.ru/image/ogimage/${this.recommendation?._id}.jpg`,

    //     type: 'image/jpeg',
    //     width: 1200,
    //     height: 630,
    //   }
    // },
    seoTitle() {
      let materialTitle = this.preText

      materialTitle = materialTitle
        ?.replace(/<(.|\n)*?>/g, '')
        .replace(/&nbsp;/g, ' ')
        .trim()
        .slice(0, 60)

      const subText = `| ${this.targetName} отзывы и рекомендации | Мегасреда`

      return `${materialTitle} ${subText}`
    },
    publishDateFormat() {
      const date = new Date(this.recommendation?.publishDate)
      const dd = ('0' + String(date.getDate())).slice(-2)
      const MM = ('0' + String(date.getMonth() + 1)).slice(-2)
      const yy = ('0' + String(date.getFullYear() % 100)).slice(-2)
      const hh = ('0' + String(date.getHours())).slice(-2)
      const mm = ('0' + String(date.getMinutes())).slice(-2)
      const ss = ('0' + String(date.getSeconds())).slice(-2)

      return `${dd}.${MM}.${yy}, ${hh}:${mm}:${ss}`
    },
    seoDescription() {
      const text = this.recommendation?.text
      if (text?.blocks?.length) {
        const paragrafs = text?.blocks.filter(
          (block) => block.type === 'paragraph'
        )

        if (paragrafs?.length > 2) {
          const sanitizeText = paragrafs[1]?.data?.text.replace(
            /<(.|\n)*?>/g,
            ''
          ) // Вырезаем все теги из текста
          return `${sanitizeText.slice(
            0,
            280
          )}... - читайте подробнее в материале от ${
            this.recommendation?.author.type === 'COMPANY'
              ? 'компании'
              : 'пользователя'
          } ${this.authorName} (@${
            this.recommendation?.author.username
          }) опубликованном ${this.publishDateFormat}`
        } else if (paragrafs?.length !== 0) {
          const sanitizeText = paragrafs[0]?.data?.text.replace(
            /<(.|\n)*?>/g,
            ''
          ) // Вырезаем все теги из текста

          return `${sanitizeText.slice(
            0,
            280
          )}... - читайте подробнее в материале от ${
            this.recommendation?.author?.type === 'COMPANY'
              ? 'компании'
              : 'пользователя'
          } ${this.authorName} (@${
            this.recommendation?.author?.username
          }) опубликованном ${this.publishDateFormat}`
        } else {
          return `Читайте подробнее в материале от ${
            this.recommendation?.author?.type === 'COMPANY'
              ? 'компании'
              : 'пользователя'
          } ${this.authorName} (@${
            this.recommendation?.author?.username
          }) опубликованном ${this.publishDateFormat}`
        }
      }
      return `Читайте подробнее в материале от ${
        this.recommendation?.author?.type === 'COMPANY'
          ? 'компании'
          : 'пользователя'
      } ${this.authorName} (@${
        this.recommendation?.author?.username
      }) опубликованном ${this.publishDateFormat}`
    },
    shareTitle() {
      if (this.recommendation.title) {
        return this.recommendation.title
      } else if (this.recommendation?.text) {
        const text = this.recommendation.text
        if (text?.blocks?.length) {
          let preText = text.blocks.filter(
            (block) => block.type === 'paragraph'
          )
          preText = preText.slice(0, 1).map((p) => {
            return p.data.text
          })

          preText = preText.join(' ')
          const sanitizeText = preText.replace(/<a[^>]*>|<\/a>/gi, '') // Вырезаем тег ссылки
          return sanitizeText
        }
      }
      return null
    },
    shareDescription() {
      const text = this.recommendation.text
      if (text?.blocks?.length) {
        let preText = text.blocks.filter((block) => block.type === 'paragraph')
        preText = preText.slice(0, 3).map((p) => {
          return p.data.text
        })

        preText = preText.join(' ')
        const sanitizeText = preText.replace(/<a[^>]*>|<\/a>/gi, '') // Вырезаем тег ссылки
        return sanitizeText
      }
      return null
    },
    isAdmin() {
      return !!this.$auth?.user?.roles?.some((role) =>
        ['ADMIN', 'MODERATOR', 'ACCOUNTER'].includes(role)
      )
    },

    isAuthor() {
      if (this.recommendation?.author?._id) {
        return this.$auth?.user?._id === this.recommendation?.author._id
      } else {
        return false
      }
    },
    authorName() {
      if (this.recommendation?.author?.type === 'COMPANY') {
        return this.recommendation?.author.company.title
          ? this.recommendation?.author?.company?.title
          : this.recommendation?.author?.username
      } else {
        return this.recommendation?.author?.profile?.firstName &&
          this.recommendation?.author?.profile?.lastName
          ? `${this.recommendation?.author?.profile?.firstName} ${this.recommendation?.author?.profile?.lastName}`
          : this.recommendation?.author?.username
      }
    },
    targetName() {
      return this.$author.authorName(this.recommendation?.target)
    },
    preText() {
      if (this.recommendation?.text) {
        const text = this.recommendation.text
        if (text?.blocks?.length) {
          const preText = text.blocks.find(
            (block) => block.type === 'paragraph'
          )
          const sanitizeText = preText?.data?.text.replace(/<(.|\n)*?>/g, '')
          return sanitizeText
        }
      }
      return null
    },
  },

  created() {
    if (process?.client) {
      this.$eventBus.$on('updateSubscriptions', async () => {
        await this.fetchRecommendation()
      })
    }
  },
  beforeDestroy() {
    this.$eventBus.$off('updateSubscriptions')
  },
  methods: {
    setView() {
      this.$axios.$post('/activity/view/recommendation', {
        username: this.author?.username,
        recommendationId: this.recommendation._id,
      })
    },

    async fetchRecommendation() {
      const { recommendation } = await this.$axios.$get(
        `/recommendations/${this.$route.params.id}`
      )
      this.recommendation = recommendation
    },

    closeMenu() {
      this.isShowMenu = false
    },
    removePost() {
      this.$router.push('/')
    },
  },
}
